import PropTypes from 'prop-types';

const MpValidationOption = PropTypes.shape({
  yes: PropTypes.bool.isRequired,
  hideInput: PropTypes.bool.isRequired,
  disableOption: PropTypes.bool.isRequired
});

export const MpValidationOptionsPropTypes = PropTypes.shape({
  mp_permissionEmail: MpValidationOption,
  mp_permissionPhone: MpValidationOption,
  mp_permissionSMS: MpValidationOption
});

export const ContentfulImagePropTypes = PropTypes.shape({
  file: PropTypes.shape({
    url: PropTypes.string.isRequired
  })
});

export const ContentTextAreaPropTypes = PropTypes.shape({
  raw: PropTypes.string.isRequired
});
